import React from 'react';

import fpvOnePilotProduct from '../../../main/assets/images/fpvonepilot/fpv-one-pilot-product.webp';

export const Hero = () => {
  return (
    <section className="fpv-pilot-hero-section-parent">
      <div className="fpv-pilot-hero-section">
        <div className="fpv-pilot-hero-text">
          <div className="fpv-pilot-hero-titles">
            <h1 className="fpv-pilot-hero-subtitle">FPV.One Pilot</h1>
            <h2 className="fpv-pilot-hero-title">
              <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                Evolved.
              </span>
              <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                Digital Ready.
              </span>
            </h2>
          </div>
          <p className="fpv-pilot-hero-description">
            Most advanced FPV goggles for immersive drone flying experiences.
          </p>
          <div className="dreamX__discover--button">
            <a
              href="https://shop.orqafpv.com/products/orqa-orqa-fpv-one-pilot"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary btn--med"
              onMouseDown={event => event.preventDefault()}
            >
              buy now
            </a>
          </div>
        </div>
        <div className="fpv-pilot-hero-image">
          <img
            src={fpvOnePilotProduct}
            alt="FPV One Pilot Product"
            className="fpv-pilot-hero-product"
          />
        </div>
      </div>
    </section>
  );
};
